import axiosInsAcademy from '@/api/axios-ugems-academy.js';

export default {
  // Get all position levels
  getPositionLevels(params) {
    return axiosInsAcademy.get('/position-levels', { params });
  },

  // Get position level detail by ID
  getPositionLevelById(id) {
    return axiosInsAcademy.get(`/position-levels/${id}`);
  },

  // Create position level
  createPositionLevel(data) {
    return axiosInsAcademy.post('/position-levels', data);
  },

  // Update position level
  updatePositionLevel(id, data) {
    return axiosInsAcademy.put(`/position-levels/${id}`, data);
  },

  // Delete position level
  deletePositionLevel(id) {
    return axiosInsAcademy.delete(`/position-levels/${id}`);
  }
};
